import React from "react";

import { LEADERSHIP_MONITOR_SCHEDULE, MONITOR_SCHEDULES, MonitorSchedule } from "src/web/constants";

const ScheduleEntry: React.FC<{ schedule: MonitorSchedule }> = ({ schedule }) => (
    <React.Fragment key={schedule.refreshes}>
        <dt>{schedule.refreshes}</dt>
        <dd>
            <div>{schedule.cadence}</div>
            <div>{schedule.detail}</div>
        </dd>
    </React.Fragment>
);

export const MonitorSchedules: React.FC = () => (
    <dl>
        {MONITOR_SCHEDULES.map((schedule) => (
            <ScheduleEntry key={schedule.refreshes} schedule={schedule} />
        ))}
    </dl>
);

export const LeadershipMonitorSchedule: React.FC = () => (
    <dl>
        <ScheduleEntry schedule={LEADERSHIP_MONITOR_SCHEDULE} />
    </dl>
);

export default MonitorSchedules;
